module.exports = __webpack_public_path__ + "static/img/14f.3874c0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14f.jpg
// module id = bGk4
// module chunks = 0